import { Fragment } from 'react';
import { initializeChakraComponent } from 'Shared/chakra-initialize';
import ActivityDisplay from './activity';
import InfoDisplay from './info';
import Navigation from './navigation';

const LandingPage = ({ navLinks, optionLinks, images, lang, activity, pageTitle, onIfixit }) => (
   <Fragment>
      <Navigation links={navLinks} pageTitle={pageTitle} onIfixit={onIfixit} />
      <InfoDisplay images={images} lang={lang} links={optionLinks} />
      <ActivityDisplay data={activity} />
   </Fragment>
);

initializeChakraComponent('CommunityLanding', LandingPage);
